import { APIErrorResponse } from "shared/api/api";

import APIError from "features/ui/APIError";

interface Props {
  error: APIErrorResponse;
}

const AppLoadError = ({ error }: Props) => (
  <div className="flex h-dvh items-center justify-center p-8">
    <div className="w-full max-w-2xl">
      <APIError error={error} />
    </div>
  </div>
);

export default AppLoadError;
